/**
 * Kill switch for unified FusionMSI chrome (VoxPont settings slot + branded auth chip).
 *
 * WHAT: Single on-by-default flag. Set localStorage FUSION_UNIFIED_CHROME=0 (or build with
 *       REACT_APP_FUSION_UNIFIED_CHROME=0) to restore two gears + generic /auth routing.
 * WHY: Lets us ship the chrome merge and roll it back without a code hunt or second identity.
 * Coupling: AppSettingsMenu, AppAuthIndicator, VoxPontProductSwitcherButton, ProductSettingsContext.
 */

export const FUSION_UNIFIED_CHROME_STORAGE_KEY = 'FUSION_UNIFIED_CHROME';

/**
 * @returns {boolean} true unless explicitly disabled via localStorage or build env.
 */
export function isUnifiedProductChromeEnabled() {
  if (typeof process !== 'undefined' && process.env?.REACT_APP_FUSION_UNIFIED_CHROME === '0') {
    return false;
  }
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage?.getItem(FUSION_UNIFIED_CHROME_STORAGE_KEY) !== '0';
  } catch {
    return true;
  }
}

const unifiedProductChrome = {
  FUSION_UNIFIED_CHROME_STORAGE_KEY,
  isUnifiedProductChromeEnabled,
};
export default unifiedProductChrome;
